"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.rem = rem;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set-timeout"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-float"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_WIDTH = 750;

function rem() {
  var designWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BASE_WIDTH;
  var rem2px = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timer = null;

  function init() {
    var docEl = document.documentElement;
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

    function adapt() {
      var d = window.document.createElement('p');
      var head = window.document.getElementsByTagName('head')[0];
      d.style.width = '1rem';
      d.style.display = 'none';
      head.appendChild(d);
      var fontSize = (0, _parseFloat2.default)(getComputedStyle(d).width);
      head.removeChild(d);
      return fontSize;
    }

    var defaultFontSize = adapt();

    function recalc() {
      var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      if (!clientWidth) {
        timer = null;
        return;
      }

      if (clientWidth < BASE_WIDTH) {
        // eslint-disable-next-line no-underscore-dangle
        window.__BaseFontSize = clientWidth / designWidth * rem2px;
        docEl.style.fontSize = "".concat(clientWidth / designWidth * rem2px / defaultFontSize * 100, "%");
      } else {
        docEl.style.fontSize = '625%';
      }

      timer = null;
    }

    function onResize() {
      if (timer) {
        return;
      }

      timer = window.setTimeout(recalc, 30);
    }

    recalc();
    window.addEventListener(resizeEvt, onResize, false); // reset rem unit on page resize

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        onResize();
      }
    });
    window.addEventListener('load', onResize); // eslint-disable-next-line no-magic-numbers

    (0, _setTimeout2.default)(onResize, 500);
  }

  init();
}